// 声音类型
export const VOICE_AUTH_TYPE = {
    VIP: 0, // vip拥有
    SVIP: 1, // svip拥有
    PRIVATE: 2, // 私人
    PAID: 3,// 付费版声音
}

// 声音范围类型
export const VOICE_RANGE_TYPE = {
    ANYONE: 1, //    选择任意一款声音
    SOMEONE: 2, //    指定一款可用声音
    ANYONE_PAID: 3,// 选择任意一款付费声音
    ALL_CHN: 4, // 全场声音包（仅中文发音人）
    ALL_VIP: 5, // 全场声音包（仅会员发音人）
    ALL: 6, // 全场声音包
}

// 声音包类型
// export const VOICE_PACKAGE_TYPE = {
//     SOME: 1, // 指定某些发音人（通过声音包查询到发音人）
//     ALL_PAID: 2, // 全场声音包（仅付费发音人）
//     ALL_CHN: 3, // 全场声音包（仅中文发音人）
//     ALL_VIP: 4, // 全场声音包（仅会员发音人）
//     ALL: 5, // 全场声音包
// }